import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { BeraV2Service } from '@/infra/services/bera-v2';

import type { BeraRevisionSource, BeraRevisionSourceLookup } from '@/types/Bera';
import type { Response } from '@/types';

type GetBeraRevisionSourceResult = UseMutationResult<
	BeraRevisionSource | null,
	AxiosError<Response>,
	BeraRevisionSourceLookup
>;

const Service = BeraV2Service.getInstance();

export function useGetBeraRevisionSource(): GetBeraRevisionSourceResult {
	return useMutation<BeraRevisionSource | null, AxiosError<Response>, BeraRevisionSourceLookup>({
		mutationFn: async (params: BeraRevisionSourceLookup) => Service.findRevisionSource(params),
		onError: (err: AxiosError<Response>) => {
			message.error(I18n.get(err.response?.data?.message ?? 'Failed to check for an existing evaluation'));
		}
	});
}
